<template>
	<div class="case-prize">
		<div>
			<el-button size="small" type="primary" @click="handleAdd">添加Roll房活动</el-button>
		</div>
		<div>
			<el-table :data="dataList" v-loading="loading">
				<el-table-column prop="id" label="ID"></el-table-column>
				<el-table-column prop="remarks" label="备注"></el-table-column>
				<el-table-column prop="type" label="类型" width="">
					<template slot-scope="scope">
						<span v-if="scope.row.type=== 1">账户余额必须大于{{scope.row.amount}}</span>
						<span v-if="scope.row.type=== 2">时间段消费金额必须大于{{scope.row.amount}}</span>
						<span v-if="scope.row.type=== 3">时间段充值金额必须大于{{scope.row.amount}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="金额"></el-table-column>
				<el-table-column prop="period" label="时间间隔"></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<el-button type="success" v-if="scope.row.state == 1" @click="val =>changeConfig(scope.row,0)">开</el-button>
						<el-button type="info" v-else @click="val =>changeConfig(scope.row,1)">关</el-button>
					</template>
				</el-table-column>
				<el-table-column label="活动中心展示">
					<template slot-scope="{row}">
            <span v-if="row.show">显示</span>
            <span v-else>不显示</span>
					</template>
				</el-table-column>
				<el-table-column prop="updated_at" label="更新时间"></el-table-column>
				<el-table-column label="操作" width="300px">
					<template slot-scope="{ row }">
						<el-button size="small" type="primary" @click="handlePrize(row)">奖品</el-button>
						<el-button type="primary" plain @click="handleEdit(row)">编辑</el-button>
						<el-button type="info" @click="handleHistory(row.id)">中奖记录</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog
			:visible.sync="visible"
			:title="isEdit ? '编辑roll房活动' : '添加roll房活动'"
			width="400px"
			:close-on-click-modal="false"
		>
			<el-form :model="formData" label-width="100px" :rules="rules" ref="form">
				<el-form-item prop="amount" label="金额限制">
					<el-input v-model="formData.amount"></el-input>
				</el-form-item>
				<el-form-item prop="period" label="时间间隔">
					<el-input v-model="formData.period" placeholder="单位分钟"></el-input>
				</el-form-item>
				<el-form-item prop="type" label="类型">
					<el-select v-model="formData.type">
						<el-option label="账户余额" :value="1"></el-option>
						<el-option label="时间段消费金额" :value="2"></el-option>
						<el-option label="时间段充值金额" :value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="show" label="活动中心显示">
					<el-select v-model="formData.show">
						<el-option label="是" :value="1"></el-option>
						<el-option label="否" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="remarks" label="备注">
					<el-input v-model="formData.remarks"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button
					size="small"
					type="primary"
					@click="submit"
					:loading="buttonLoading"
				>确 定</el-button
				>
      </span>
		</el-dialog>
		<el-dialog
			:visible.sync="historyVisible"
			title="中奖历史记录"
			width="800px"
			:close-on-click-modal="false"
		>
			<el-table :data="historyData" v-loading="loading">
				<el-table-column prop="id" label="ID"></el-table-column>
				<el-table-column prop="prize" label="奖品"></el-table-column>
				<el-table-column prop="user" label="中奖用户"></el-table-column>
				<el-table-column prop="created_at" label="中奖时间"></el-table-column>
			</el-table>
			<el-pagination
				background
				:total="dataMeta ? dataMeta.total : 0"
				:current-page="dataMeta ? dataMeta.current_page : 1"
				:page-size="dataMeta ? dataMeta.per_page : 15"
				@current-change="handlePageChange"
			></el-pagination>
		</el-dialog>
	</div>
</template>

<script>
	import { delApiData, patchApiData, getApiData, postApiData } from '../../http'

	export default {
		data() {
			return {
				dataList: undefined,
				historyData: undefined,
				formData: {
					// people: undefined,
					amount: undefined,
					period: undefined,
					type: 1,
					state: 1,
          show:1,//0在活动中心显示 1在活动中心不显示 默认是1
					remarks: undefined
				},
				rules: {
					// people: [{ required: true, message: '人数不能为空' }],
					amount: [{ required: true, message: '限制金额不能为空' }],
					period: [{ required: true, message: '时间间隔不能为空' }],
					// type: [{ required: true, message: '类型不能为空' }],
					state: [{ required: true, message: '状态不能为空' }]
				},
				page: 1,
				prizePage: 1,
				editInfo: undefined,
				loading: false,
				visible: false,
				buttonLoading: false,
				isEdit: false,
				historyVisible: false,
				roll_id: undefined,
				dataMeta: {}
			}
		},
		methods: {
			getData() {
				this.loading = true
				getApiData(`rollActivity`, { page: this.page })
					.then(res => {
						this.dataList = res
					})
					.finally(() => {
						this.loading = false
					})
			},
			handleAdd() {
				this.isEdit = false
				this.editInfo = undefined
				this.visible = true
			},
			handleEdit(row) {
				this.isEdit = true
				this.editInfo = row
				this.visible = true
				this.formData = row
			},
			handlePrize(row) {
				let routeData = this.$router.resolve({path: `/roll_activity/${row.id}`})
				window.open(routeData.href, '_blank')
			},
			handleHistory(id) {
				this.roll_id = id
				this.historyVisible = true
				this.historyData = undefined
				this.dataMeta = undefined
				getApiData(`rollActHistory/${id}`, { page: this.page })
					.then(res => {
						this.historyData = res.data
						this.dataMeta = res.meta
					})
					.finally(() => {
						this.loading = false
					})
			},
			changeConfig(row, state) {
				let str = ''
				if (state === 1) {
					str = '打开'
				} else {
					str = '关闭'
				}
				this.$confirm('此操作将' + str + '当前状态, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					patchApiData('rollActivityStatus/' + row.id, {
						state: state
					})
						.then(
							res => {
								this.$message.success('修改设置成功')
								this.getData()
							}
						)
						.finally(() => {
							// this.loading = false
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					})
				})
			},
			handlePageChange(page) {
				this.page = page
				this.handleHistory(this.roll_id)
			},
			handleDelete(id) {
				this.$confirm('确定要删除吗？', {
					type: 'warning'
				}).then(res => {
					delApiData(`rollActivity/${id}`).then(res => {
						this.$message.success('删除成功')
						this.getData()
					})
				})
			},
			submit() {
				this.$refs['form'].validate(valid => {
					if (valid) {
						this.buttonLoading = true
						if (!this.editInfo) {
							postApiData(`rollActivity`, {
								...this.formData
							})
								.then(res => {
									this.buttonLoading = false
									this.visible = false
									this.$message.success('添加成功')
									this.getData()
								})
								.finally(() => {
									this.buttonLoading = false
								})
						} else {
							patchApiData(`rollActivity/${this.editInfo.id}`, {
								people: this.formData.people,
								amount: this.formData.amount,
								period: this.formData.period,
								type: this.formData.type,
								state: this.formData.state,
								show: this.formData.show,
								remarks: this.formData.remarks
							})
								.then(res => {
									this.buttonLoading = false
									this.visible = false
									this.$message.success('编辑成功')
									this.getData()
								})
								.finally(() => {
									this.buttonLoading = false
								})
						}
					}
				})
			}
		},
		created() {
			this.getData()
		}
	}
</script>
